export function Button({ children, className = "", ...props }) {
  return (
    <button
      {...props}
      className={`px-5 py-3 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 transition ${className}`}
    >
      {children}
    </button>
  );
}
